/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
// assets
import StyledSkeleton from './styles';


const Skeleton = (props) => {
  const { mb, height, width } = props;

  return (
    <StyledSkeleton mb={mb} height={height} width={width}>
      <span>{' '}</span>
    </StyledSkeleton>
  );
};

Skeleton.defaultProps = {};
Skeleton.propTypes = {};

export default Skeleton;
